export const MuiSwitch = {
  styleOverrides: {
    root: {
      width: 42,
      height: 24,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      left: '-2px',
      padding: '2px 0 2px 4px',
      color: '#fff',

      '&.Mui-checked': {
        transform: 'translateX(17px)',

        '& + .MuiSwitch-track': {
          backgroundColor: 'blue',
          opacity: 1,
        },
        '&.Mui-disabled': {
          color: '#fff',
          '& + .MuiSwitch-track': {
            backgroundColor: '#ccc',
            opacity: 1,
          },
        },
      },

      '&.Mui-disabled': {
        opacity: 1,
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#ccc',
          opacity: 1,
        },
      },
    },
    track: {
      backgroundColor: '#ccc',
      borderRadius: 16,
      opacity: 1,
    },
    thumb: {
      width: 20,
      height: 20,
      boxShadow: 'none',
      color: '#fff',
    },
  },
};
